import { render, staticRenderFns } from "./TopTenListArticle.vue?vue&type=template&id=41d5c6e3&"
import script from "./TopTenListArticle.vue?vue&type=script&lang=js&"
export * from "./TopTenListArticle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports